import {
  ChangeDetectionStrategy, Component, Input,
} from '@angular/core';

@Component({
  selector: 'procure-environment-banner',
  templateUrl: './environment-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class EnvironmentBannerComponent {
  @Input()
  public identifier?: string;
}
